import { IonIcon, IonImg, IonLabel, isPlatform } from "@ionic/react";
import React, { useState } from "react";
import { COLLECTIONS, deleteDataFromFireStore } from "../../../firebase";
import PopUpVehicles from "../../OnBoarding/PopUpVehicles";
import Geocode from "react-geocode";
import UserAddressModal from "../../../utils/UserAddressModal";
import { cart } from "ionicons/icons";

export const PageHeaderWithLoc: React.FC = (props: any) => {
  const [showCarVehicles, setCarVehicles] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);
  const getUserCurrentLocation = () => {
    navigator.geolocation.getCurrentPosition(
      (resp) => {
        const { coords } = resp;
        const { latitude, longitude } = coords;
        props.storeCurrentLatLong(latitude, longitude);
        Geocode.fromLatLng(latitude, longitude).then(
          (response: any) => {
            const address = response.results[0].formatted_address;
            props.storeUserMapAddress(address);
          },
          (error: any) => {
            console.error(error, "error");
          },
        );
      },
      (e: any) => console.error(e, "e"),
    );
  };

  const openCartInMobile = () => {
    props.history.push("/portal/cart");
  };

  const deleteAddressData = (addressId: any) => {
    deleteDataFromFireStore(props.uid, addressId, COLLECTIONS.USERS, COLLECTIONS.ADDRESSES);
    props.deleteAddress(addressId);
  };
  const [carReg, setCarReg] = React.useState({
    model: "",
    reg: "",
  });
  React.useEffect(() => {
    if (props.onBoarding) {
      const data =
        props.userVehiclesList.length &&
        props.userVehiclesList.find(
          (ele: any) => ele.did === (props.selectedVehicleRef || "").split("/").pop(),
        );
      if (!!data) {
        setCarReg({
          model: data.model,
          reg: data.registrationNumber
            ? data.registrationNumber.slice(data.registrationNumber.length - 4)
            : "",
        });
      }
      setCarVehicles(false);
    }
  }, [props.userVehiclesList, props.selectedVehicleRef]);

  return (
    <div
      className="bs_header_parent wholeApp"
      style={{ paddingTop: isPlatform("android") ? 20 : 0 }}
    >
      <div className="bs_header_rowcenter">
        <IonImg
          src="/images/left_arrow_gray.svg"
          onClick={() =>
            props.location.pathname === "/portal/service_details" ||
            props.location.pathname === "/portal/body-panel"
              ? props.history.push("/portal/book_service")
              : props.location.pathname === "/portal/book_service"
              ? props.history.push("/portal/dashboard")
              : props.history.goBack()
          }
          className="bs_header_leftarrow"
        />
        <UserAddressModal {...props} />
      </div>
      <div className="icon_cart">
        <div className="cart_child_icon" onClick={() => openCartInMobile()}>
          {Boolean(props.service_data.length) && (
            <div className="cart-count">
              <IonLabel className="notification_count_text">{props.service_data.length}</IonLabel>
            </div>
          )}
          <IonImg src="/images/cart_gray.svg" className="gray_cart_img" />
          {/* <IonIcon
            icon={cart}
            className="cart_icon"
            color="tertiary"
            onClick={() => openCartInMobile()}
            // onClick={() => goToconfirm()}
          /> */}
        </div>
        <PopUpVehicles {...props} />
      </div>
      {/* address modal */}
    </div>
  );
};
